import React from 'react';
import { FaFacebook, FaInstagram, FaYoutube } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&family=DM+Sans:wght@400;500;600&display=swap');
.ft{background:linear-gradient(135deg,#0b3d4a 0%,#0e3a4a 100%);color:rgba(255,255,255,.75);font-family:'DM Sans',sans-serif;padding:3.5rem 2rem 0;}
.ft-inner{max-width:1200px;margin:0 auto;display:grid;grid-template-columns:2fr 1fr 1fr 1fr;gap:2.5rem;padding-bottom:3rem;}
.ft-brand-name{font-family:'Playfair Display',serif;font-size:1.3rem;font-weight:700;color:#fff;margin:0 0 .6rem;}
.ft-brand-tagline{font-size:.85rem;color:rgba(255,255,255,.55);line-height:1.65;margin:0 0 1.25rem;max-width:26ch;}
.ft-socials{display:flex;gap:.65rem;}
.ft-social{width:36px;height:36px;border-radius:50%;display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,.1);border:1px solid rgba(255,255,255,.15);color:#fff;text-decoration:none;transition:all .2s;}
.ft-social:hover{background:rgba(243,156,18,.3);border-color:rgba(243,156,18,.5);transform:translateY(-2px);}
.ft-col-title{font-family:'DM Sans',sans-serif;font-size:.68rem;font-weight:600;letter-spacing:.14em;text-transform:uppercase;color:rgba(255,255,255,.4);margin:0 0 1rem;}
.ft-links{list-style:none;padding:0;margin:0;display:flex;flex-direction:column;gap:.5rem;}
.ft-links li button{background:none;border:none;color:rgba(255,255,255,.6);font-family:'DM Sans',sans-serif;font-size:.88rem;cursor:pointer;padding:0;transition:color .2s;text-align:left;}
.ft-links li button:hover{color:#f39c12;}
.ft-contact-item{font-size:.85rem;color:rgba(255,255,255,.55);line-height:1.6;margin-bottom:.5rem;}
.ft-contact-item a{color:rgba(255,255,255,.65);text-decoration:none;transition:color .2s;}
.ft-contact-item a:hover{color:#f39c12;}
.ft-bottom{border-top:1px solid rgba(255,255,255,.07);padding:1.25rem 0;display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:.5rem;max-width:1200px;margin:0 auto;}
.ft-copyright{font-size:.78rem;color:rgba(255,255,255,.3);}
.ft-reg{font-size:.72rem;color:rgba(255,255,255,.2);letter-spacing:.04em;}
@media(max-width:860px){.ft-inner{grid-template-columns:1fr 1fr;}.ft-bottom{flex-direction:column;text-align:center;}}
@media(max-width:500px){.ft-inner{grid-template-columns:1fr;}}
`;

const socials = [
  {id:'fb', url:'https://www.facebook.com/vseva.11org/',  Icon:FaFacebook,  label:'Facebook'},
  {id:'ig', url:'https://www.instagram.com/v_seva__/',    Icon:FaInstagram, label:'Instagram'},
  {id:'yt', url:'https://www.youtube.com/@VIVEKASEVA',    Icon:FaYoutube,   label:'YouTube'},
];

export default function Footer() {
  const navigate = useNavigate();
  const year = new Date().getFullYear();

  const links = [
    {label:'Home',      path:'/'},
    {label:'About',     path:'/about'},
    {label:'Projects',  path:'/projects'},
    {label:'Volunteer', path:'/volunteer'},
    {label:'Donate',    path:'/donate'},
    {label:'Contact',   path:'/contact'},
  ];

  return (
    <footer className="ft">
      <style>{CSS}</style>
      <div className="ft-inner">
        {/* brand */}
        <div>
          <p className="ft-brand-name">Viveka Seva Trust</p>
          <p className="ft-brand-tagline">Empowering lives through education and social service. Join us in making a difference.</p>
          <div className="ft-socials">
            {socials.map(({id,url,Icon,label})=>(
              <a key={id} href={url} target="_blank" rel="noopener noreferrer" className="ft-social" aria-label={label}>
                <Icon size={15}/>
              </a>
            ))}
          </div>
        </div>
        {/* nav */}
        <div>
          <p className="ft-col-title">Navigate</p>
          <ul className="ft-links">
            {links.map(l=>(
              <li key={l.path}><button onClick={()=>navigate(l.path)}>{l.label}</button></li>
            ))}
          </ul>
        </div>
        {/* contact */}
        <div>
          <p className="ft-col-title">Contact</p>
          <div className="ft-contact-item"><a href="mailto:vivekaseva.org@gmail.com">vivekaseva.org@gmail.com</a></div>
          <div className="ft-contact-item"><a href="tel:+917483865803">+91 74838 65803</a></div>
          <div className="ft-contact-item">Hanumanth Nagar,<br/>Bengaluru – 560019</div>
        </div>
        {/* trust info */}
        <div>
          <p className="ft-col-title">Registration</p>
          <div className="ft-contact-item">MSME Registered</div>
          <div className="ft-contact-item" style={{fontSize:'.78rem',color:'rgba(255,255,255,.35)'}}>UDYAM-KR-03-0569132</div>
          <div className="ft-contact-item" style={{marginTop:'.75rem'}}>Est. 2020 · Bengaluru</div>
        </div>
      </div>
      <div className="ft-bottom">
        <span className="ft-copyright">© {year} Viveka Seva Trust. All rights reserved.</span>
        <span className="ft-reg">MSME · UDYAM-KR-03-0569132</span>
      </div>
    </footer>
  );
}